import { object, string, number, mixed, ObjectSchema, InferType, date } from "yup";
import { ServiceInvoiceStatusEnum } from "../../../shared/utils/enum/enum";
import { ServiceInvoiceContract } from "../contracts/criar-entrada-de-notas.contracts";

export const criarEntradaDeNotasSchema: ObjectSchema<ServiceInvoiceContract> = object({
  number: string().required("É obrigatório informar o número da nota fiscal!"),
  idWork: string().nullable().optional().default(null),
  dps: string().nullable().optional().default(null),
  series: string().nullable().optional().default(null),
  idClient: string().nullable().optional().default(null),
  incidenceMunicipalityCode: string().required("É obrigatório informar o código do município de incidência do ISSQN!"),
  issueDate: date().required("É obrigatório informar a data de emissão!"),
  competenceDate: date().required("É obrigatório informar a data de competência!"),
  verificationCode: string().required("É obrigatório informar o código de verificação!"),
  providerName: string().required("É obrigatório informar o nome do prestador!"),
  providerCnpj: string().required("É obrigatório informar o CNPJ do prestador!"),
  providerMunicipalRegistration: string().required("É obrigatório informar a inscrição municipal do prestador!"),
  providerAddress: string().required("É obrigatório informar o endereço do prestador!"),
  providerPhone: string().nullable().optional().default(null),
  providerEmail: string().nullable().optional().default(null),
  customerName: string().required("É obrigatório informar o nome do tomador!"),
  customerCnpj: string().required("É obrigatório informar o CNPJ do tomador!"),
  customerMunicipalRegistration: string().required("É obrigatório informar a inscrição municipal do tomador!"),
  customerAddress: string().required("É obrigatório informar o endereço do tomador!"),
  customerPhone: string().nullable().optional().default(null),
  customerEmail: string().nullable().optional().default(null),
  serviceDescription: string().required("É obrigatório informar a discriminação do serviço!"),
  municipalTaxCode: string().required("É obrigatório informar o código de tributação do município!"),
  serviceListSubitem: string().required("É obrigatório informar o subitem da lista de serviços!"),
  serviceListDescription: string().optional(),
  operationNature: string().required("É obrigatório informar a natureza da operação!"),
  specialTaxRegime: string().required("É obrigatório informar o regime especial de tributação!"),
  serviceValue: number()
    .typeError("O valor líquido deve ser um número!")
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
        if (!cleaned) return undefined;
        const valorNumber = Number(cleaned);
        return isNaN(valorNumber) ? undefined : valorNumber;
      }
      return value;
    })
    .required("É obrigatório informar o valor líquido!")
    .max(99999999.99, "Valor líquido muito alto!")
    .default(0),
  discounts: number().typeError("Os descontos devem ser um número!").required("É obrigatório informar os descontos!"),
  federalRetentions: number().typeError("As retenções federais devem ser um número!").required("É obrigatório informar as retenções federais!"),
  issWithheld: number().typeError("O ISS retido deve ser um número!").required("É obrigatório informar o ISS retido!"),
  netValue: number()
    .typeError("O valor líquido deve ser um número!")
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
        if (!cleaned) return undefined;
        const valorNumber = Number(cleaned);
        return isNaN(valorNumber) ? undefined : valorNumber;
      }
      return value;
    })
    .required("É obrigatório informar o valor líquido!")
    .max(99999999.99, "Valor líquido muito alto!")
    .default(0),
  deductions: number().typeError("As deduções devem ser um número!").required("É obrigatório informar as deduções!"),
  unconditionalDiscount: number().typeError("O desconto incondicionado deve ser um número!").required("É obrigatório informar o desconto incondicionado!"),
  calculationBase: number().typeError("A base de cálculo deve ser um número!").required("É obrigatório informar a base de cálculo!"),
  aliquot: string().optional().default(null),
  issValue: number().optional().default(null),
  accessKey: string().required("É obrigatório informar a chave de acesso da nota fiscal!"),
  otherInfo: string().nullable().optional().default(null),
  status: mixed<ServiceInvoiceStatusEnum>()
    .oneOf(Object.values(ServiceInvoiceStatusEnum), "Status inválido")
    .required("É obrigatório informar o status da nota fiscal!"),
});

export type CriarEntradaDeNotasFormData = InferType<typeof criarEntradaDeNotasSchema>;